import React from 'react'

const ListItem = ({className,children}) => {
    return (
       <li className={className}>{children}</li>
    )
}

export default ListItem
